import { CashRegisterStateEnum, ReceiptTypeEnum } from "@prostocheck/shared";

import { TBadgeTone } from "./badge.models";

export const BADGE_TONE_CLASS: Record<TBadgeTone, string> = {
  neutral: "bg-surface-muted text-ink-700 ring-ink-900/10",
  brand: "bg-brand-50 text-brand-700 ring-brand-500/20",
  success: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  danger: "bg-rose-50 text-rose-700 ring-rose-600/20",
  warning: "bg-amber-50 text-amber-700 ring-amber-600/20",
};

export const CASH_REGISTER_STATE_TONE: Record<
  CashRegisterStateEnum,
  TBadgeTone
> = {
  [CashRegisterStateEnum.Active]: "success",
  [CashRegisterStateEnum.Suspended]: "warning",
  [CashRegisterStateEnum.Closed]: "neutral",
};

/** Keys in the `common` namespace of `@prostocheck/i18n`. */
export const CASH_REGISTER_STATE_LABEL_KEY: Record<
  CashRegisterStateEnum,
  string
> = {
  [CashRegisterStateEnum.Active]: "cashRegisterState.active",
  [CashRegisterStateEnum.Suspended]: "cashRegisterState.suspended",
  [CashRegisterStateEnum.Closed]: "cashRegisterState.closed",
};

export const RECEIPT_TYPE_TONE: Record<ReceiptTypeEnum, TBadgeTone> = {
  [ReceiptTypeEnum.Sale]: "success",
  [ReceiptTypeEnum.Return]: "danger",
  [ReceiptTypeEnum.Service]: "neutral",
};

export const RECEIPT_TYPE_SHORT_LABEL_KEY: Record<ReceiptTypeEnum, string> = {
  [ReceiptTypeEnum.Sale]: "receiptType.sale",
  [ReceiptTypeEnum.Return]: "receiptType.return",
  [ReceiptTypeEnum.Service]: "receiptType.service",
};
